/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (_, UpgradeBase, WidgetUpgradeUtils) => {

	class RankSlotUpgrade extends UpgradeBase {

		constructor() {
			super();

			this.VERSION = 1027;
		}

		/**
		 * Perform upgrade to remove rank slots. Hidden rank slots were being persisted in the spec 
		 * before the rank refactoring. Now we don't create and use rank slots.
		 * @param {object} spec - spec to perform upgrade on
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {

			if (!spec) {
				return Promise.resolve(spec);
			}
			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			return this._upgradeWidgets(spec);

		}

		down(spec) {
			// Downgrades are not available in CA
			return Promise.resolve(spec);
		}

		_upgradeWidgets(spec) {
			try{
				_.each(spec.widgets, model => {
					this._upgradeWidget(model);
				});
				return Promise.resolve(spec);

			} catch(error){
				throw error;
			}

		}

		_upgradeWidget(model) {
			if (model.slotmapping && model.slotmapping.slots && model.slotmapping.slots.length) {
				model.slotmapping.slots = _.filter(model.slotmapping.slots, slot => slot.name !== 'rank');
			}
		}

	}

	return new RankSlotUpgrade();

});
